/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReceiptExtraction = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 16H2V6a4 4 0 0 1 4-4h8.5C15.8 2 17 3.046 17 4.444V10h-3v6H8v2h10.586l-1.293-1.293 1.414-1.414 3 3 .707.707-.707.707-3 3-1.414-1.414L18.586 20H6v-4H3zM6 4a2 2 0 0 0-2 2v8h8V4.444c0-.152.014-.3.041-.444H6zm8.86.148A.532.532 0 0 0 14.5 4a.532.532 0 0 0-.36.148.41.41 0 0 0-.14.296V8h1V4.444a.41.41 0 0 0-.14-.296zM6 10h4v2H6v-2zm0-4h4v2H6V6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgReceiptExtraction as ReceiptExtraction };
